import Typography from '@cobliteam/ui/components/Typography';
import { cn } from '@cobliteam/ui/utils';
import { PrismicRichText as BasePrismicRichText, type JSXMapSerializer, type PrismicRichTextProps } from '@prismicio/react';
import type { HTMLAttributes } from 'react';

const defaultComponents = (className: string): JSXMapSerializer => {
  return {
    heading1: ({ children }) => (
      <Typography variant='heading-2xl' className={className}>
        {children}
      </Typography>
    ),
    heading2: ({ children }) => (
      <Typography variant='heading-xl' className={className}>
        {children}
      </Typography>
    ),
    heading3: ({ children }) => (
      <Typography variant='heading-lg' className={className}>
        {children}
      </Typography>
    ),
    heading4: ({ children }) => (
      <Typography variant='heading-md' className={className}>
        {children}
      </Typography>
    ),
    paragraph: ({ children }) => (
      <Typography variant='text-md' className={className}>
        {children}
      </Typography>
    ),
    strong: ({ children }) => (
      <Typography variant='text-md-semibold' as={'strong'} className={cn(className)}>
        {children}
      </Typography>
    ),
  };
};

type ExtendedPrismicRichTextProps = PrismicRichTextProps & HTMLAttributes<HTMLDivElement>;

export function PrismicRichText({ components, className, ...props }: ExtendedPrismicRichTextProps) {
  return <BasePrismicRichText components={{ ...defaultComponents(className ?? ''), ...components }} {...props} />;
}
